export default "__VITE_ASSET__BEyDU1Kc__"